import { useQuery } from '@tanstack/react-query';
import { useParams } from 'react-router-dom';

import { CategoryBannerApi } from '../../../lib/api/category/CategoryBannerApi';
import { CATEGORY } from '../../../constants/queryKeys';
import { CategoryBannerResponse } from '../../../lib/api/category/categoryBannerType';

export const useCategoryBanner = () => {
  const { id } = useParams<{ id: string }>();
  const categoryId = Number(id);

  return useQuery<CategoryBannerResponse>({
    queryKey: [...CATEGORY.BANNER, id],
    queryFn: () => CategoryBannerApi.getCategoryBanner(categoryId),
    enabled: !Number.isNaN(categoryId),
  });
};
